/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dice_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Each roll uses your browser's random generator with every face equally likely, just like a well-balanced physical die.`)
};

const es_dice_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Cada tirada usa el generador aleatorio de tu navegador con igual probabilidad para cada cara, igual que un dado físico bien equilibrado.`)
};

const de_dice_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Jeder Wurf nutzt den Zufallsgenerator deines Browsers, bei dem jede Seite gleich wahrscheinlich ist — genau wie bei einem gut ausgewuchteten echten Würfel.`)
};

const nl_dice_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Elke worp gebruikt de willekeurige generator van je browser waarbij elk vlak evenveel kans heeft, net als bij een goed uitgebalanceerde fysieke dobbelsteen.`)
};

const fr_dice_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Chaque lancer utilise le générateur aléatoire de votre navigateur avec une probabilité égale pour chaque face, tout comme un dé physique bien équilibré.`)
};

const it_dice_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Ogni lancio usa il generatore casuale del tuo browser con ogni faccia ugualmente probabile, proprio come un dado fisico ben bilanciato.`)
};

const pt_br2_dice_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Cada rolagem usa o gerador aleatório do navegador com todas as faces igualmente prováveis, assim como um dado físico bem equilibrado.`)
};

const pt_dice_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Cada lançamento usa o gerador aleatório do seu navegador, com todas as faces igualmente prováveis, tal como um dado físico bem equilibrado.`)
};

const ja_dice_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。各ロールはブラウザの乱数生成機能を使い、すべての面が等確率で出ます — バランスの取れた実物のサイコロと同じです。`)
};

const zh_dice_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。每次投掷都使用浏览器的随机数生成器，每一面概率相同，就像一枚平衡良好的实体骰子。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dice_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dice_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dice_faq_a1", locale)
	if (locale === "en") return en_dice_faq_a1(inputs)
	if (locale === "es") return es_dice_faq_a1(inputs)
	if (locale === "de") return de_dice_faq_a1(inputs)
	if (locale === "nl") return nl_dice_faq_a1(inputs)
	if (locale === "fr") return fr_dice_faq_a1(inputs)
	if (locale === "it") return it_dice_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_dice_faq_a1(inputs)
	if (locale === "pt") return pt_dice_faq_a1(inputs)
	if (locale === "ja") return ja_dice_faq_a1(inputs)
	return zh_dice_faq_a1(inputs)
};